module.exports = __webpack_public_path__ + "static/media/20180522-LCS-001-1.2f071e27.jpg";